<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    max-width="700"
    scrollable
  >
    <v-card v-if="element">
      <v-card-title>
        <v-list-item class="ml-n4">
          <v-list-item-avatar size="44" class="mr-3">
            <v-img :src="avatar_img" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title
              class="text-subtitle-1 font-weight-medium text-truncate"
              >{{ nome }}</v-list-item-title
            >
            <v-list-item-subtitle>
              <span v-if="periodo_label" class="mr-1"
                >{{ periodo_label }} &mdash;</span
              >
              Totale:
              <strong>{{ element.qta_verde + element.qta_blu }}</strong> pz
              &nbsp;&middot;&nbsp; Verde:
              {{ element.qta_verde }} &nbsp;&middot;&nbsp; Blu:
              {{ element.qta_blu }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-btn icon small @click="$emit('input', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item>
      </v-card-title>
      <v-tabs v-model="tab" height="32" background-color="grey lighten-4">
        <v-tab class="text-caption">Colori</v-tab>
        <v-tab class="text-caption">Trend settimanale</v-tab>
        <v-tab class="text-caption">Per cliente</v-tab>
      </v-tabs>
      <v-divider />
      <v-card-text class="pt-3" style="height: 380px; overflow-y: auto">
        <!-- ─── TAB COLORI ─── -->
        <template v-if="tab === 0">
          <v-row v-if="loading_colori" justify="center" class="mt-8">
            <v-progress-circular indeterminate width="2" color="primary" />
          </v-row>
          <template v-else>
          <v-alert
            v-if="colori_data && colori_data.avviso"
            type="info"
            dense
            text
            class="mb-3 text-caption"
            icon="mdi-information-outline"
          >
            {{ colori_data.avviso }}
          </v-alert>
          <v-row
            no-gutters
            class="font-weight-medium text-caption grey--text mb-2"
          >
            <v-col cols="7">Colore</v-col>
            <v-col cols="3">Distribuzione</v-col>
            <v-col cols="2" class="d-flex justify-end pr-2">%</v-col>
          </v-row>
          <div v-for="(group, gi) in colori_per_serie" :key="gi">
            <!-- intestazione serie -->
            <v-row no-gutters align="center" class="mt-2 mb-1">
              <v-col cols="12">
                <span
                  class="text-caption font-weight-bold text-uppercase"
                  :class="group.serie ? 'primary--text' : 'grey--text'"
                >
                  {{ group.serie || 'Senza serie' }}
                </span>
                <v-divider class="mt-1" />
              </v-col>
            </v-row>
            <!-- righe colore -->
            <v-hover
              v-for="col in group.colori"
              :key="col.id"
              v-slot="{ hover }"
            >
              <v-row
                no-gutters
                align="center"
                class="my-1 px-1 rounded"
                :class="hover ? 'grey lighten-4' : ''"
              >
                <v-col cols="7" class="d-flex align-center text-body-2">
                  <v-avatar size="22" class="mr-2 flex-shrink-0">
                    <v-img :src="colore_img(col)" />
                  </v-avatar>
                  {{ col.nome }}
                </v-col>
                <v-col cols="3" class="d-flex align-center pr-3">
                  <div style="width:100%; background:#eeeeee; border-radius:4px; height:6px; overflow:hidden;">
                    <div
                      style="height:100%; background:#1976D2; border-radius:4px;"
                      :style="{ width: colori_tot ? (col.qta_ordinata / colori_tot * 100).toFixed(1) + '%' : '0%' }"
                    />
                  </div>
                </v-col>
                <v-col cols="2" class="d-flex justify-end pr-2 text-body-2 font-weight-medium">
                  {{ colori_tot ? (col.qta_ordinata / colori_tot * 100).toFixed(1) + '%' : '—' }}
                </v-col>
              </v-row>
            </v-hover>
          </div>
          </template>
        </template>

        <!-- ─── TAB TREND ─── -->
        <template v-else-if="tab === 1">
          <v-row no-gutters align="center" class="mb-4">
            <v-select
              :items="trend_periodi"
              v-model="trend_periodo"
              label="Periodo trend"
              item-value="value"
              item-text="label"
              hide-details
              dense
              outlined
              style="max-width: 220px"
            />
          </v-row>
          <v-row v-if="loading_trend" justify="center" class="mt-8">
            <v-progress-circular indeterminate width="2" color="green" />
          </v-row>
          <template v-else-if="chart_buckets.length">
            <VueApexCharts
              type="bar"
              height="260"
              :options="chart_options"
              :series="chart_series"
            />
          </template>
          <v-row v-else justify="center" class="mt-8 grey--text text-caption">
            Nessun dato per il periodo selezionato
          </v-row>
        </template>

        <!-- ─── TAB PER CLIENTE ─── -->
        <template v-else-if="tab === 2">
          <v-row v-if="loading_clienti" justify="center" class="mt-8">
            <v-progress-circular indeterminate width="2" color="primary" />
          </v-row>
          <template v-else-if="clienti_prodotto.length">
            <v-row no-gutters class="font-weight-medium text-caption grey--text mb-2">
              <v-col :cols="show_confronta ? 5 : 9">Cliente</v-col>
              <v-col :cols="show_confronta ? 2 : 3" class="d-flex justify-end pr-2">Qta</v-col>
              <template v-if="show_confronta">
                <v-col cols="2" class="d-flex justify-end pr-2">{{ anno_confronto }}</v-col>
                <v-col cols="3" class="d-flex justify-end pr-2">Var %</v-col>
              </template>
            </v-row>
            <v-hover
              v-for="(c, i) in clienti_lista_merged"
              :key="i"
              v-slot="{ hover }"
            >
              <v-row
                no-gutters
                align="center"
                class="my-1 px-1 rounded"
                :class="hover ? 'grey lighten-4' : ''"
              >
                <v-col :cols="show_confronta ? 5 : 9" class="d-flex align-center text-body-2">
                  <v-icon small class="mr-2" color="blue-grey">mdi-account</v-icon>
                  <span class="text-truncate">{{ nome_cliente(c.iva) }}</span>
                </v-col>
                <v-col :cols="show_confronta ? 2 : 3" class="d-flex justify-end pr-2 text-body-2 font-weight-medium">
                  {{ c.qta }}
                </v-col>
                <template v-if="show_confronta">
                  <v-col cols="2" class="d-flex justify-end pr-2 text-body-2 grey--text">
                    {{ clienti_confronto_map[c.iva] || '—' }}
                  </v-col>
                  <v-col cols="3" class="d-flex justify-end pr-2 text-body-2" :class="varClass(c.qta, clienti_confronto_map[c.iva])">
                    {{ varPct(c.qta, clienti_confronto_map[c.iva]) }}
                  </v-col>
                </template>
              </v-row>
            </v-hover>
          </template>
          <v-row v-else justify="center" class="mt-8 grey--text text-caption">
            Nessun cliente nel periodo
          </v-row>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import _ from "lodash";
import VueApexCharts from "vue-apexcharts";
export default {
  components: { VueApexCharts },
  props: {
    value: Boolean,
    element: Object,
    show_confronta: Boolean,
    anno_confronto: Number,
    ts_inizio: [String, Number],
    ts_fine: [String, Number],
  },
  data() {
    return {
      tab: 0,
      trend_data: [],
      loading_trend: false,
      colori_data: null,
      loading_colori: false,
      clienti_prodotto: [],
      clienti_prodotto_confronto: [],
      loading_clienti: false,
      trend_periodo: 90,
      trend_periodi: [
        { label: "Ultimo mese", value: 30 },
        { label: "Ultimi 3 mesi", value: 90 },
        { label: "Ultimi 6 mesi", value: 180 },
        { label: "Ultimo anno", value: 365 },
      ],
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.tab = 0;
        this.trend_data = [];
        this.colori_data = null;
        this.clienti_prodotto = [];
        this.clienti_prodotto_confronto = [];
        this.fetchColori();
      }
    },
    tab(val) {
      if (val === 0 && !this.colori_data) this.fetchColori();
      if (val === 1 && !this.trend_data.length) this.fetchTrend();
      if (val === 2 && !this.clienti_prodotto.length) this.fetchClienti();
    },
    trend_periodo() {
      if (this.tab === 1) this.fetchTrend();
    },
  },
  computed: {
    periodo_label() {
      if (!this.ts_inizio || !this.ts_fine) return null;
      const wkStart = moment.unix(this.ts_inizio).isoWeek();
      const yrStart = moment.unix(this.ts_inizio).isoWeekYear();
      const wkEnd = moment.unix(this.ts_fine).isoWeek();
      const yrEnd = moment.unix(this.ts_fine).isoWeekYear();
      if (wkStart === wkEnd && yrStart === yrEnd) return `Wk ${wkStart}`;
      if (yrStart === yrEnd) return `Wk ${wkStart} – Wk ${wkEnd}`;
      return `Wk ${wkStart}/${yrStart} – Wk ${wkEnd}/${yrEnd}`;
    },
    prodotto() {
      if (!this.element) return null;
      return this.$store.getters.get_prodotto_by_id(this.element.id);
    },
    nome() {
      if (!this.prodotto) return "";
      return this.prodotto.nome.split(" in ")[0];
    },
    avatar_img() {
      if (!this.prodotto) return "";
      return `${process.env.VUE_APP_API_ROOT}/avatar_img/${this.prodotto.id}?t=${this.prodotto.avatar_md5}`;
    },
    clienti_confronto_map() {
      const map = {};
      this.clienti_prodotto_confronto.forEach((c) => { map[c.iva] = c.qta; });
      return map;
    },
    clienti_lista_merged() {
      if (!this.show_confronta) return this.clienti_prodotto;
      const merged = this.clienti_prodotto.map((c) => ({ ...c }));
      const ivaSet = new Set(this.clienti_prodotto.map((c) => c.iva));
      this.clienti_prodotto_confronto.forEach((c) => {
        if (!ivaSet.has(c.iva)) merged.push({ iva: c.iva, qta: 0 });
      });
      return merged;
    },
    colori_agg() {
      return this.colori_data ? this.colori_data.colori : [];
    },
    colori_tot() {
      return this.colori_agg.reduce((s, c) => s + (c.qta_ordinata || 0), 0);
    },
    colori_per_serie() {
      const groups = [];
      const seen = new Map();
      this.colori_agg.forEach((col) => {
        const key = col.nome_serie || '';
        if (!seen.has(key)) {
          seen.set(key, groups.length);
          groups.push({ serie: col.nome_serie || null, colori: [] });
        }
        groups[seen.get(key)].colori.push(col);
      });
      return groups;
    },
    by_month() {
      return this.trend_periodo >= 180;
    },
    chart_buckets() {
      const valid = this.trend_data.filter(
        (r) => r.timeStamp && Number(r.timeStamp) > 0
      );
      const buckets = [];
      if (this.by_month) {
        const byMonth = _.groupBy(valid, (r) =>
          moment.unix(r.timeStamp).startOf("month").format("YYYY-MM")
        );
        const start = moment()
          .subtract(this.trend_periodo, "days")
          .startOf("month");
        const end = moment().startOf("month");
        let cur = start.clone();
        while (cur.isSameOrBefore(end)) {
          const key = cur.format("YYYY-MM");
          buckets.push({ key, records: byMonth[key] || [] });
          cur.add(1, "month");
        }
      } else {
        const byWeek = _.groupBy(valid, (r) =>
          moment.unix(r.timeStamp).startOf("isoWeek").format("YYYY-MM-DD")
        );
        const start = moment()
          .subtract(this.trend_periodo, "days")
          .startOf("isoWeek");
        const end = moment().startOf("isoWeek");
        let cur = start.clone();
        while (cur.isSameOrBefore(end)) {
          const key = cur.format("YYYY-MM-DD");
          buckets.push({ key, records: byWeek[key] || [] });
          cur.add(1, "week");
        }
      }
      return buckets;
    },
    chart_series() {
      return [
        {
          name: "Verde",
          data: this.chart_buckets.map((b) =>
            b.records.filter((r) => r.verde).reduce((s, r) => s + (r.qta || 0), 0)
          ),
        },
        {
          name: "Blu",
          data: this.chart_buckets.map((b) =>
            b.records.filter((r) => !r.verde).reduce((s, r) => s + (r.qta || 0), 0)
          ),
        },
      ];
    },
    chart_options() {
      return {
        chart: { type: "bar", stacked: true, toolbar: { show: false } },
        colors: ["#00E676", "#448AFF"],
        plotOptions: { bar: { borderRadius: 2, columnWidth: "60%" } },
        xaxis: {
          categories: this.chart_buckets.map((b) =>
            this.by_month
              ? moment(b.key).format("MMM YY")
              : moment(b.key).format("DD MMM")
          ),
          labels: { style: { fontSize: "11px" }, rotate: -45 },
        },
        yaxis: { labels: { style: { fontSize: "11px" } } },
        legend: { position: "top", fontSize: "12px" },
        dataLabels: { enabled: false },
        tooltip: {
          x: {
            formatter: (_, opts) => {
              const b = this.chart_buckets[opts.dataPointIndex];
              if (!b) return "";
              return this.by_month
                ? moment(b.key).format("MMMM YYYY")
                : `Sett. ${moment(b.key).format("DD MMM")} – ${moment(b.key)
                    .endOf("isoWeek")
                    .format("DD MMM YYYY")}`;
            },
          },
        },
      };
    },
  },
  methods: {
    colore_img(col) {
      return `${process.env.VUE_APP_API_ROOT}/prodotto/${this.element.id}/img_colore/${col.id}`;
    },
    varPct(corrente, confronto) {
      if (!confronto) return "N/D";
      return ((corrente * 100) / confronto - 100).toFixed(0) + " %";
    },
    varClass(corrente, confronto) {
      if (!confronto) return "grey--text";
      return corrente >= confronto ? "green--text" : "red--text";
    },
    nome_cliente(iva) {
      const c = this.$store.getters.get_cliente_by_iva(iva);
      return c ? c.nome : iva;
    },
    fetchColori() {
      if (!this.element) return;
      this.loading_colori = true;
      this.$store
        .dispatch("fetch_prodotto_colori", {
          id_prodotto: this.element.id,
          ts_inizio: this.ts_inizio,
          ts_fine: this.ts_fine,
        })
        .then((data) => { this.colori_data = data || null; })
        .finally(() => { this.loading_colori = false; });
    },
    fetchClienti() {
      if (!this.element) return;
      this.loading_clienti = true;
      const delta = moment().year() - this.anno_confronto;
      const ts_inizio_rif = moment.unix(this.ts_inizio).subtract(delta, "year").format("X");
      const ts_fine_rif = moment.unix(this.ts_fine).subtract(delta, "year").format("X");
      const main = this.$store
        .dispatch("fetch_prodotto_clienti", {
          id_prodotto: this.element.id,
          ts_inizio: this.ts_inizio,
          ts_fine: this.ts_fine,
        })
        .then((data) => { this.clienti_prodotto = Array.isArray(data) ? data : []; });
      const fetches = [main];
      if (this.show_confronta) {
        const cf = this.$store
          .dispatch("fetch_prodotto_clienti", {
            id_prodotto: this.element.id,
            ts_inizio: ts_inizio_rif,
            ts_fine: ts_fine_rif,
          })
          .then((data) => { this.clienti_prodotto_confronto = Array.isArray(data) ? data : []; });
        fetches.push(cf);
      }
      Promise.all(fetches).finally(() => { this.loading_clienti = false; });
    },
    fetchTrend() {
      if (!this.element) return;
      this.loading_trend = true;
      this.trend_data = [];
      this.$store
        .dispatch("fetch_prodotto_venduto", {
          id_prodotto: this.element.id,
          ts_inizio: moment()
            .subtract(this.trend_periodo, "days")
            .startOf("day")
            .format("X"),
          ts_fine: moment().format("X"),
        })
        .then((data) => {
          this.trend_data = Array.isArray(data) ? data : [];
        })
        .finally(() => {
          this.loading_trend = false;
        });
    },
  },
};
</script>
